import { type I18n } from "@common/lib/i18n";
import { type MemberVerification } from "./types";

export const getOperationLabel = (i18n: I18n, type: MemberVerification.Api.VerificationType): string => {
  switch (type) {
    case "AccountTransactionWithdrawal":
      return i18n.withdrawal;
  }
};
